import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Stack,
} from '@mui/material';

interface ConfirmAddPlotDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  plotName?: string;
  plotNumber?: string;
  siteName?: string;
}

/**
 * Confirmation dialog for adding a plot
 * Molecule component following Atomic Design Structure
 */
export function ConfirmAddPlotDialog({
  open,
  onClose,
  onConfirm,
  plotName,
  plotNumber,
  siteName,
}: ConfirmAddPlotDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Add Plot</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to create this plot?
        </Typography>
        <Box sx={{ mt: 2, p: 2, backgroundColor: 'grey.50', borderRadius: 1 }}>
          <Stack spacing={1}>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Plot Name
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {plotName}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Plot Number
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {plotNumber}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Site
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {siteName}
              </Typography>
            </Box>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
